module.exports = __webpack_public_path__ + "static/media/wab32_1018.88c777d5.ico";